import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { setbadgeJson, handleImageEleModal } from "BadgeDesignAction";
import LocaleStrings from "Languages";

class ElementList extends Component {
  constructor(props) {
    super(props);
  }

  // show / hide element on badge
  _handelBadgeElement = (ele) => {
    let { templateJson } = this.props;
    // console.log("ele", ele);
    // console.log("templateJson", templateJson);

    // On check uncheck make true / false in json [array of object -> in store ]
    _.map(templateJson, (value, index) => {
      if (ele.name === value.name) {
        if (ele.hidden === true) {
          value.hidden = false;
        } else {
          value.hidden = true;
        }
      }
    });
    // console.log("templateJson :- ", templateJson);
    this.props.setbadgeJson(templateJson); // Update to store

    let elements = document.getElementById(
      `badge_elements[${ele.displayOrder}]`
    );
    elements.click();
    // console.log("elements :- ", elements);
  };

  // remove custom element
  _removeBadgeElement = (ele) => {
    let { templateJson } = this.props;
    // console.log("ele", ele);
    // console.log("templateJson :- ", templateJson);

    let newJson = _.filter(templateJson, (o) => {
      return o.name !== ele.name;
    });

    let newLevelVal = 1;
    _.map(newJson, (value, index) => {
      value.displayOrder = index;

      if (value.iscustom && value.htmlType === "input") {
        value.id = "input_" + newLevelVal;
        value.name = "#input_" + newLevelVal;
        value.handle = ".handle-input_" + newLevelVal + " move";
        value.levelVal = newLevelVal;

        newLevelVal++;
      }
    });

    this.props.setbadgeJson(newJson); // Update to store
    this.props.handelElementChange(); // detect element change for submit button disable

    if (!ele.hidden) {
      let elements = document.getElementById(
        "badge_elements[" + ele.displayOrder + "]"
      );
      elements.click();
      // console.log("elements :- ", elements);
    }
  };

  _handleReuploadImage = () => {
    this.props.handleImageEleModal({
      show: true,
      data: this.props.data,
    });
  };

  render() {
    let { data, selectedElement } = this.props;
    // console.log("data :- ", data);

    let view = "fa fa-eye badge-element-added";
    if (data.hidden) {
      view = "fa fa-eye-slash badge-element-not-added";
    }

    return (
      <div
        className={
          selectedElement && selectedElement.name === data.name
            ? "badge-element-list-data-selected"
            : "badge-element-list-data"
        }
      >
        <span className="custom-text1-primary-normal">
          {data.checkboxLabel}
        </span>

        <div className="vertical-align-center gap-3">
          {data.iscustom ? (
            <>
              {data.htmlType === "image" ? (
                <span
                  className="badge-image-element-reupload"
                  onClick={this._handleReuploadImage}
                >
                  {LocaleStrings.button_reupload}
                </span>
              ) : (
                ""
              )}
              <i
                className={"fa fa-trash badge-element-delete"}
                onClick={() => this._removeBadgeElement(data)}
                aria-hidden="true"
              ></i>
            </>
          ) : (
            ""
          )}
          <i
            className={view}
            onClick={() => this._handelBadgeElement(data)}
            aria-hidden="true"
          ></i>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    templateJson: state.templateJson,
    selectedElement: state.selectedElement,
  };
}

export default connect(mapStateToProps, { setbadgeJson, handleImageEleModal })(
  ElementList
);
